// extracted by mini-css-extract-plugin
module.exports = {"error":"edit_error_38G2r"};